import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import CancelRoundedIcon from '@material-ui/icons/CancelRounded';


interface IAsyncAutocompleteProps {
  placeholder: string;
  disabled?: boolean;
  className?: string;
  options: any[];
  queryText: string;
  value?: any;
  setOptionSelected: (val: any) => void;
  onQueryTextChange: (q: string) => void;
}

export default function AsyncAutocomplete(props: IAsyncAutocompleteProps) {
  const { placeholder, options, queryText, setOptionSelected, onQueryTextChange, ...rest } = props;
  const [open, setOpen] = React.useState(false);
  const loading = open && options.length === 0 && queryText.length >=1


  return (
    <Autocomplete
    closeIcon={<CancelRoundedIcon color="disabled"/>}

      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      loadingText="Start Typing..."
      getOptionSelected={(option, value) => option.institutionName === value.institutionName}
      getOptionLabel={(option) => option.institutionName}
      options={options}
      loading={loading}
      onChange={(_event, value) => setOptionSelected(value)}
      onInputChange={(_event, value) => onQueryTextChange(value)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={placeholder}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
          
        />
      )}
      {...rest}
    />
  );
}